export type AppEnv = 'dev' | 'stg' | 'prd'

type RawAppConfig = {
  TENANTSERVICE_API_URL?: string
  PROVISIONING_API_URL?: string
  KEYCLOAK_URL?: string
  KEYCLOAK_REALM?: string
  KEYCLOAK_CLIENT_ID?: string
  APP_ENV?: string
  USE_MOCKS?: boolean
}

declare global {
  interface Window {
    APP_CONFIG?: RawAppConfig
  }
}

const cfg: RawAppConfig =
  (globalThis as unknown as Window & { APP_CONFIG?: RawAppConfig }).APP_CONFIG ?? {}

const VALID_ENVS: readonly AppEnv[] = ['dev', 'stg', 'prd']

function useMocks(): boolean {
  return cfg.USE_MOCKS === true
}

// Required only when not mocking: with USE_MOCKS the SPA runs on fixtures with no
// backend/Keycloak, so the URL/Keycloak keys are optional and must never throw.
function required(value: string | undefined, name: string): string {
  if (value) return value
  if (useMocks()) return ''
  throw new Error(`Missing runtime config: ${name}`)
}

function appEnv(): AppEnv {
  return VALID_ENVS.includes(cfg.APP_ENV as AppEnv) ? (cfg.APP_ENV as AppEnv) : 'dev'
}

export const appConfig = {
  tenantServiceUrl: (): string => required(cfg.TENANTSERVICE_API_URL, 'TENANTSERVICE_API_URL'),
  provisioningUrl: (): string => required(cfg.PROVISIONING_API_URL, 'PROVISIONING_API_URL'),
  keycloakUrl: (): string => required(cfg.KEYCLOAK_URL, 'KEYCLOAK_URL'),
  keycloakRealm: (): string => required(cfg.KEYCLOAK_REALM, 'KEYCLOAK_REALM'),
  keycloakClientId: (): string => required(cfg.KEYCLOAK_CLIENT_ID, 'KEYCLOAK_CLIENT_ID'),
  appEnv,
  useMocks,
}
